import React from 'react';
import Button from '../../../Components/commonButton/commonButton'
import ReadOnlyTextField from '../../../Components/readOnlyTextField/readOnlyTextField'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import Select from '../../../Components/select/select'
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css"

export default class DelOp extends React.Component {
    state = {
            PO_code_array: [], arr_idcodes: [], id: 0, code: "", production_batch: "",
            piece_code: "", id_machine: null, piece_hour:"", date_op: "", machine: "",
            piece_production:"",show: false, message: "",piece_cicle:"", notification: false, notification_type: 'success', notification_message: ''
        }
    
    componentDidMount() {
        Api.get('/production-orders-web/').then((resp) => {
            let arr = []
            let arr_PO = []
            resp.data.response.forEach(element => {
                arr.push({value:element.id,label:element.code})
                arr_PO.push({ id: element.id, code: element.code })
            });
            this.setState({ PO_code_array: arr })
            this.setState({ arr_idcodes: arr_PO })
        }).catch((error) => {
            if (error.response) {
                alert(error.response.data + '\n' + error.response.status + '\n' + error.response.headers)
            }
        })
    }

    selectPoCode = (childData) => {
        Api.get(`/production-orders-id/${childData}`).then((resp) => {
            const { code, piece_code,pph,
            date_created,piece_production,piece_cicle,machine } = resp.data
            this.setState({code: code,id:childData, piece_code: piece_code,
                piece_hour: pph, date_op: date_created,
                piece_production:piece_production,piece_cicle:piece_cicle,machine:machine
            })
        })
    }

    callbackfunction = () => { this.setState({ show: false }) }

    sendData = async (id) => {
        if(this.state.id > 0){
            await Api.delete(`/production-orders/${id}`).then(resp => {
                this.setState({notification: true, notification_message: "Ordem deletada com sucesso!"});
                setTimeout(()=>{
                    return window.location.reload();
                },2000)
            }).catch((error) => {
                if (error.response) {
                    alert(error.response.data + '\n' + error.response.status + '\n' + error.response.headers)
                }
            })
        }else{
            this.setState({show:true,message:"Selecione uma produção."})
        }
        
    }

    render() {
        let { show, message,PO_code_array, notification, notification_message, notification_type } = this.state
        return (
            <div className='box'>
                <div className="input_fields_add_orders form">
                    <h4>Deletar Ordem</h4>
                    {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
                    {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} /> : null}
                    <div className='inputs'>
                        <div className='selectDelOrder element'><Select autoSelect={true} label={"Ordens de Produção"}  arrData={PO_code_array} handleSelect={this.selectPoCode}/></div>
                        <div className='tf1DelOrder element'><ReadOnlyTextField showValue={this.state.piece_code} title="Código da Peça" /></div>
                        <div className='tf2DelOrder element'><ReadOnlyTextField showValue={this.state.date_op} title="Data" /></div>
                        <div className='tf3DelOrder element' id="qtdpecas"><ReadOnlyTextField showValue={this.state.piece_production} title="Qtd. de peças á produzir" /></div>
                    </div>
                    <div className='btnDelOrder submitButton'><Button title="Apagar" parentCallback={() => this.sendData(this.state.id)} /></div>
                </div>
            </div>
        )
    }
}